import { render, staticRenderFns } from "./Features.vue?vue&type=template&id=5eb2289a&lang=pug"
import script from "./Features.vue?vue&type=script&lang=coffee"
export * from "./Features.vue?vue&type=script&lang=coffee"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports